import { render, staticRenderFns } from "./CompareObjects.vue?vue&type=template&id=1b5a7b26&scoped=true&"
import script from "./CompareObjects.vue?vue&type=script&lang=ts&"
export * from "./CompareObjects.vue?vue&type=script&lang=ts&"
import style0 from "./CompareObjects.vue?vue&type=style&index=0&id=1b5a7b26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a7b26",
  null
  
)

export default component.exports